// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"styles_loginForm__2v5pX","loginFormElement":"styles_loginFormElement__3Seay"};